import {PromotionProvider} from '@/context/Promotion/PromotionContext'
import {CreatePromotion as CreatePromotionNorthAmerica} from '@/features/Promotions/CreatePromotion'
import {selectIsNewDesignCountry} from '@/store/slices/countryCodeSlice'
import {useSelector} from 'react-redux'
import CreatePromotion from './CreatePromotion'

/**
 * Promotion editor shell backed by Promotion context.
 * Selects legacy or new themed create promotion flow by country.
 * @returns {JSX.Element}
 */
export const PromotionEditor = () => {
  const isNewDesignCountry = useSelector(selectIsNewDesignCountry)

  return <PromotionProvider>{isNewDesignCountry ? <CreatePromotionNorthAmerica /> : <CreatePromotion />}</PromotionProvider>
}
